<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="6">
                <el-input placeholder="设备编号" v-model="dev_id"></el-input>
            </el-col>
            <el-col :span="18">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="dev_id" label="设备编号">
            </el-table-column>
            <el-table-column prop="dev_version" label="产品类型">
            </el-table-column>
            <el-table-column label="固件Log">
                <template slot-scope="scope">
                    <el-switch
                        v-if="edit==scope.row.id"
                        v-model="scope.row.model_log"
                        active-color="#13ce66"
                        inactive-color="#eeeeee">
                    </el-switch>
                    <div v-else>{{scope.row.model_log?'开':'关'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="角速度开关">
                <template slot-scope="scope">
                    <el-switch
                        v-if="edit==scope.row.id"
                        v-model="scope.row.angular_fault"
                        active-color="#13ce66"
                        inactive-color="#eeeeee">
                    </el-switch>
                    <div v-else>{{scope.row.angular_fault?'开':'关'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="加速度开关">
                <template slot-scope="scope">
                    <el-switch
                        v-if="edit==scope.row.id"
                        v-model="scope.row.acce_fault"
                        active-color="#13ce66"
                        inactive-color="#eeeeee">
                    </el-switch>
                    <div v-else>{{scope.row.acce_fault?'开':'关'}}</div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button v-if="edit==scope.row.id" @click="Save(scope.row)" type="text" size="small">保存</el-button>
                    <el-button v-if="edit==scope.row.id" @click="Cancel(scope.row)" type="text" size="small">取消</el-button>
                    <el-button v-else @click="Edit(scope.row)" type="text" size="small">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
    export default {
        name: 'admin',
        data() {
            return {
                dev_id:'',
                editname:'',
                edit:0,
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        filters:{
            format(value) {
                switch(value) {
                    case 'test': return '测试环境';break;
                    case 'prod': return '生产环境';break;
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                if(this.dev_id.trim() != '') {
                    params.dev_id = this.dev_id;
                }
                this.$http.get('/manage/device-setting-info/list', {params:params}).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Edit(row) {
                this.edit = row.id;
                this.editname = row.report_env;
            },
            Save(row) {
                row.report_env = this.editname;
                let params = {
                    id: row.id,
                    report_env: row.report_env,
                    acce_fault: row.acce_fault,
                    angular_fault: row.angular_fault,
                    model_log: row.model_log
                }
                this.$http.post('/manage/device-setting-info/update',params).then(rs => {
                    if(rs.data.code == 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.edit = 0;
                    }else {
                        this.$message({
                            message: rs.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            Cancel() {
                this.edit = 0;
            }
        },
        components: { Pagination }
    }
</script>

<style scoped>
    .search-add{margin-bottom: 10px;}
</style>